import AthleteTrivia from "../components/AthleteTrivia";

const choices = [
  { number: 'A', answer: '1st pick', correct: false },
  { number: 'B', answer: '2nd pick', correct: true },
  { number: 'C', answer: '3rd pick', correct: false },
  { number: 'D', answer: '4th pick', correct: false }
]
const question = 'With which pick was Chase drafted?'
const message = 'Chase was drafted #2 overall by Washington.'

const TriviaChase = () => {
  return(
    <AthleteTrivia 
        athlete_name={'Chase'}
        closet_path={'/chase-closet'}
        video_path={'chase/chase_quiz.mp4'}
        question_id={4}
        choices={choices}
        question={question}
        message={message}
    />
  )
}
export default TriviaChase;
